import { render } from "./WorkOrderMonitoring.vue?vue&type=template&id=88a76a64"
import script from "./WorkOrderMonitoring.vue?vue&type=script&lang=js"
export * from "./WorkOrderMonitoring.vue?vue&type=script&lang=js"

import "./WorkOrderMonitoring.vue?vue&type=style&index=0&id=88a76a64&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__